import { useLogout } from '@hooks/useLogout'

const AccessUnavailable = () => {
  const logout = useLogout()

  return (
    <main className='d-flex min-vh-100 align-items-center justify-content-center p-4'>
      <section className='text-center'>
        <h1>Access unavailable</h1>
        <p>Your account is missing the access required to use the dashboard. Please contact your account administrator.</p>
        <button
          type='button'
          className='btn btn-primary'
          onClick={() => void logout('manual')}
        >
          Sign out
        </button>
      </section>
    </main>
  )
}

export default AccessUnavailable
